export default class listParamsCtrl{

  constructor($scope, GeneralSettingsSrv, $interval, $state, $timeout){
    $scope.submodules = {}
    $scope.currentSubmoduleData = {}
    $scope.models = {}
    $scope.enforce = true
    $scope.disableButton = false;
    $scope.load = true;

    GeneralSettingsSrv.getSubmodules.get().$promise.then((dataReturn) => {
    	if (dataReturn.status == true) {
    		$scope.submodules = dataReturn.data
    	} else {
    		console.log("Comunications problem with the server")
      }
    }).then(() => {
    	GeneralSettingsSrv.getListData.get({idTypeList: $scope.submodules[0].id_code}).$promise.then((dataReturn) => {
    			if (dataReturn.status == true) {
    				$scope.currentSubmoduleData = dataReturn.data;
            $scope.load = false;
    			} else {
    				console.log("Comunications problem with the server")
    			}
   		})
   	})
 
    $scope.set_color = (item, list) => {
		  const colors = [
		  	{background: "#0D47A1"},
		  	{background: "#1565C0"},
		  	{background: "#1976D2"},
		  	{background: "#1E88E5"},
		  	{background: "#2196F3"},
		  	{background: "#42A5F5"},
		  	{background: "#64B5F6"},
		  	{background: "#90CAF9"},
		  	{background: "#B3E5FC"},
		  	{background: "#E1F5FE"},
		  	{background: "#ECEFF1"},
		  	{background: "#EEEEEE"},
		  	{background: "#FAFAFA"},
		  ]
		  let idx = list.indexOf(item) % 12
		  return colors[idx]
		}

    $scope.set_color_required = (item) => {
      if (item.isRequired == 0) {
        return {background: "#1E88E5"};
      } else {
        return {background: "#EF7955"};
      }            
    }

    $scope.set_indicator_style = (isRequired) => {
      if (isRequired == true) {
        return {borderRadius: "50%", width: "15px", height: "15px", background: "#EF7955"};
      } else {
        return {borderRadius: "50%", width: "15px", height: "15px", background: "#1E88E5"};              
      }              
    }

		$scope.getData = (list) => {
      $scope.load = true;
      $scope.currentSubmoduleData = [];
    	GeneralSettingsSrv.getListData.get({idTypeList: list.id_code}).$promise.then((dataReturn) => {
    		if (dataReturn.status == true) {
   				$scope.currentSubmoduleData = dataReturn.data;
           $scope.load = false;
   			} else {
   				console.log("Comunications problem with the server")
   			}
  		})
		}

    $scope.updateView = () => {
      $scope.viewLoaded = false;
      $timeout( () => {
        $scope.viewLoaded = true;
      }, 1);
    };

		$scope.changeStatus = (item, list, status) => {
    	GeneralSettingsSrv.changeStatus.change({listId: list.idList, itemId: item.idListItem, isActive: !status})
      .$promise.then((dataReturn) => {
    		if (dataReturn.status == true) {
    			list.items[list.items.indexOf(item)].isActive = !status ? 1 : 0
    			console.log(list.items[list.items.indexOf(item)].isActive)
   			} else {
   				console.log("Problems with server item isActive was not changed")
   			}
  		})
		}

		$scope.addItem = (data, list, idx, flag) => {            
			if(data == null || data.length == 0)
			{
				return;
			}
			else
			{        
        $scope.disableButton = true;
				GeneralSettingsSrv.addListItem.add({idList: list.idList, dsName: data, isRequired: flag})
				.$promise.then((dataReturn) => {          
					if (dataReturn.status == true) {
						$scope.models[idx] = null
						list.items.push({
							"idListItem": dataReturn.data[0].insertId,
							"listItemName": data,
              "isRequired": flag,
							"nmOrder": list.items.length + 1,
							"isActive": 1
						})            
					} else {
						console.log("Comunications problem with the server")            
					}
          $scope.disableButton = false;
				})
			}
		}

 		$scope.hasError = (input) => {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

		$scope.showErrorMessages = (input) => {
      return input.$dirty || input.$touched
    }

	}
}

listParamsCtrl.$inject = ['$scope','GeneralSettingsSrv','$interval', '$state', '$timeout'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/parameters/listParamsCtrl.js